import { render } from "./V8StyleBottom.vue?vue&type=template&id=2f0b1ead&scoped=true"
import script from "./V8StyleBottom.vue?vue&type=script&lang=js"
export * from "./V8StyleBottom.vue?vue&type=script&lang=js"

import "./V8StyleBottom.vue?vue&type=style&index=0&id=2f0b1ead&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0b1ead"]])

export default __exports__